<template>
  <b-row class="pt-4 px-2">
    <b-col
      :cols="12"
      class="text-center py-4"
    >
      <font-awesome-icon
        :class="$style.icon"
        icon="envelope"
        size="6x"
      />

      <BaseTextH1 class="pt-4 mt-4">
        {{ $t('validate-your-email-to-be-able-to-win-the-prize') }}
      </BaseTextH1>
    </b-col>

    <template v-if="!isConfirmationSent">
      <b-col
        :cols="12"
        class="text-center py-4"
      >
        {{ $t('we-will-send-email-confirmation-to-the-following-email-address') }}
        <BaseTextH2>{{ user.email }}</BaseTextH2>
      </b-col>

      <b-col
        :cols="12"
        class="py-4 d-flex justify-content-center"
      >
        <BaseLoading
          v-if="isSending"
          :min-height="40"
        />
        <BaseButton
          v-else
          is-rounded
          variant="outline-orange"
          @click.native="handleResendEmailClick"
        >
          <span class="px-2">{{ $t('resend') }}</span>
        </BaseButton>
      </b-col>
    </template>

    <transition name="fade">
      <b-col
        v-if="isConfirmationSent"
        class="py-4 text-center"
        :cols="12"
      >
        <div>{{ $t('verification-email-was-successfully-sent') }}</div>
        <div>{{ $t('please-check-your-email-mailbox') }}</div>
      </b-col>
    </transition>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseTextH2 from '@/components/Atoms/Typography/BaseTextH2'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'
import BaseLoading from '@/components/Atoms/BaseLoading'

export default {
  name: 'TheVerifyEmail',
  components: { BaseLoading, BaseTextH1, BaseButton, BaseTextH2 },
  props: {
  },
  data() {
    return {
      isSending: false,
      isConfirmationSent: false,
    }
  },
  computed: {
    ...mapState({
      isUserLoading: state => state['auth'].isUserLoading,
      user: state => state['auth'].user,
      isPrizesLoading: state => state['prizes/index'].isPrizesLoading,
      prizes: state => state['prizes/index'].prizes,
    }),
  },
  methods: {
    ...mapActions({
      resendEmailValidation: 'profile/emailValidation/postResendEmailValidation',
    }),
    handleResendEmailClick() {
      this.isSending = true
      this.resendEmailValidation().then(() => {
        this.isSending = false
        this.isConfirmationSent = true
      })
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../../assets/scss/variables.scss";
  .icon {
    color: $color-tomato;
  }
</style>
